module.exports = __webpack_public_path__ + "static/media/scanner-image.4cae0c17.svg";